<div id="hierarchy-container">
  <div id="breadcrumb-container">
    <a routerLink="" preserveFragment="true" queryParamsHandling="preserve" matTooltip="Pathways overview">
      <ng-container class="icon-container">
        <mat-icon class='home-icon custom-icon primary' svgIcon="home"></mat-icon>
      </ng-container>
    </a>

    <nav class="breadcrumb">
      <div class="gradient-holder-left"></div>

      <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <!--        <span class="gutter">></span>-->
        <ng-container *ngIf="!last">
          <a class="breadcrumb-item" queryParamsHandling="preserve" [routerLink]="['/PathwayBrowser', this.pathwayId()]"
             (click)="onBreadcrumbSelect(breadcrumb)">
            <span>{{ breadcrumb.displayName }}</span>
          </a>
        </ng-container>
        <ng-container *ngIf="last">
          <!--          <span class="gutter">></span>-->
          <span class="breadcrumb-item"> {{ breadcrumb.displayName }}</span>
        </ng-container>
      </ng-container>

      <div class="gradient-holder-right"></div>
    </nav>
  </div>

  <div id="events-container">
    <mat-tree #tree [dataSource]="treeDataSource" [childrenAccessor]="childrenAccessor" [trackBy]="trackById" class="tree">
      <!-- This is the tree node template for leaf nodes -->

      <!-- stopPropagation() prevent the matTreeNodeToggle event from triggering when clicking-->
      <mat-nested-tree-node *matTreeNodeDef="let node" class="leaf-node" (click)="$event.stopPropagation()"
             [ngClass]="{'has-sibling': hasRootSiblingForLeafNode(node)}" [attr.st-id]="node.stId">

        <div class="tree-node child-less">
          <div class="left">
            <button mat-button (click)="onTreeEventSelect(node)"
                    [ngClass]="{'selected': node.isSelected, 'hovered': node.isHovered, 'hit': node.hit}"
                    class="button">
              <mat-icon [class.hitIcon]="node.hit"
                        class="custom-icon"
                        [matTooltip]="getIcon(node).tooltip"
                        [svgIcon]="getIcon(node).name">
              </mat-icon>

              <div class="name-container">
                <div class="font name"
                     (mouseover)="onNameHover($event ,node)"
                     (mouseleave)="onNameHoverLeave($event, node)"
                     (wheel)="onScroll($event, node)">
                  {{ node.displayName }}
                </div>
              </div>
            </button>
          </div>

          <div class="right">
            <div class="tag-container">
              <div class="tag" *ngIf="node.releaseStatus === 'UPDATED'" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>U</span>
                <span class="body">PDATED</span>
              </div>
              <div class="tag" *ngIf="node.releaseStatus === 'NEW'" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>N</span>
                <span class="body">EW</span>
              </div>

              <div class="tag" *ngIf="node.isInDisease" [class.disease]="node.isInDisease" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>D</span>
                <span class="body">ISEASE</span>
              </div>

              <div class="tag" *ngIf="node.isInferred" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>I</span>
                <span class="body">NFERRED</span>
              </div>

            </div>
          </div>
        </div>
      </mat-nested-tree-node>

      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: eventService.hasChild" [attr.st-id]="node.stId"
                            [cdkTreeNodeTypeaheadLabel]="node.name"
                            (click)="onTreeEventSelect(node)"
                            matTreeNodeToggle>
        <div class="tree-node">
          <!--todo: clean structure, try not use button for the event's displayName and replace click event with (expandedChange)-->
          <div class="left">
            <button #treeControlButton mat-icon-button  class="button-size no-hover-effect"
                    [attr.aria-label]="'Toggle ' + node.name" >
              <mat-icon class="mat-icon-rtl-mirror custom-icon"
                        [svgIcon]="tree.isExpanded(node) ? 'arrow-down' : 'arrow-right'"></mat-icon>
            </button>

            <button mat-button class="button"
                    [ngClass]="{'selected': node.isSelected, 'hovered': node.isHovered, 'hit': node.hit}">
              <mat-icon #eventIcon class='custom-icon' [class.ehld]="node.hasEHLD"
                        [matTooltip]="node.hasEHLD? 'Pathway with an enhanced diagram ' : 'Pathway'"
                        [svgIcon]="node.hasEHLD  ? 'pathway-ehld' : 'pathway'"></mat-icon>
              <div class="name-container">
                <div class="font name" (mouseover)="onNameHover($event, node)"
                     (mouseleave)="onNameHoverLeave($event, node)"
                     (wheel)="onScroll($event, node)">
                  {{ node.displayName }}
                </div>
              </div>
            </button>
          </div>

          <div class="right">
            <div class="tag-container">
              <div class="tag" *ngIf="node.releaseStatus === 'UPDATED'" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>U</span>
                <span class="body">PDATED</span>
              </div>
              <div class="tag" *ngIf="node.releaseStatus === 'NEW'" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>N</span>
                <span class="body">EW</span>
              </div>

              <div class="tag" *ngIf="node.isInDisease" [class.disease]="node.isInDisease"
                   (mouseover)="onTagHover(node)" (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>D</span>
                <span class="body">ISEASE</span>
              </div>

              <div class="tag" *ngIf="node.isInferred" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class='initial'>I</span>
                <span class="body">NFERRED</span>
              </div>
              <!--Only provide this subpathway tag for the first layer, ignore the nested subpathways-->
              <div class="subpathway" *ngIf="!node.hasDiagram && node.parent.stId === this.pathwayId()"
                   [style.background]="node.subpathwayColor" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
              </div>

              <div class="analysis" *ngIf="node.hitReactionsCount"
                   [style.background]="node.analysisColor" (mouseover)="onTagHover(node)"
                   (mouseleave)="onTagHoverLeave(node)">
                <span class="text" [matTooltip]="'Hit Reactions / Total Reactions'"> {{ node.hitReactionsCount }}</span>
              </div>

            </div>
          </div>
        </div>
        <!-- There is inline padding applied to this div using styles.
            This padding value depends on the mat-icon-button width.  -->
        <ul>
          <!-- Show children only when expanded -->
          <ng-container *ngIf="tree.isExpanded(node)">
            <div role="group" class="group">
              <ng-container matTreeNodeOutlet></ng-container>
            </div>
          </ng-container>

        </ul>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>
